import { Col, Container, Row } from 'reactstrap';
import PracticeDetails from './Practice/PracticeDetails';
import PracticeConfiguration from './Practice/PracticeConfiguration';
import './PracticeOverview.css';
import React from 'react';

// TODO: refactor the layout shenanigans here
const PracticeOverview = () => {
    return <Container className="mb-4">
            <Row className="d-none d-lg-flex">
                <PracticeDetails />
                <div
                    className="p-3 hover-parent-x sc-glass sc-shadow sc-rounded text-white ml-auto"
                    style={{ width: '49%' }}>
                    <PracticeConfiguration />
                </div>
            </Row>
            <Row className="d-lg-none">
                <Col
                    id="practiceInfo"
                    lg="6"
                    sm="12"
                    className="p-4 hover-parent sc-glass sc-shadow sc-rounded text-white">
                    <PracticeDetails />
                </Col>

                <Col id="separate-on-small-screens" sm="12">
                    &nbsp;
                </Col>

                <Col
                    id="datacoInfo"
                    lg="5"
                    sm="12"
                    className="p-4 hover-parent-x ml-auto text-light sc-glass sc-shadow sc-rounded">
                    <PracticeConfiguration />
                </Col>
            </Row>
        </Container>;
};

export default React.memo(PracticeOverview);
